import { View, ViewProps } from "react-native";

type Props = ViewProps & {
  direction: "row" | "column";
  justifyContent?:
    | "flex-start"
    | "flex-end"
    | "center"
    | "space-between"
    | "space-around"
    | "space-evenly";
  alignItems?: "flex-start" | "flex-end" | "center" | "stretch" | "baseline";
  wrap?: boolean;
  children: React.ReactNode;
};

export const Box: React.FC<Props> = ({
  direction,
  justifyContent,
  alignItems,
  wrap,
  style,
  children,
}) => (
  <View
    style={[
      {
        flexDirection: direction,
        justifyContent,
        alignItems,
        flexWrap: wrap ? "wrap" : "nowrap",
      },
      style,
    ]}
  >
    {children}
  </View>
);
